import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { DatePipe } from '@angular/common';

import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';


import { FormularService } from 'src/app/Services/formular.service';
import { StatisticForm } from '../statistic.model';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import { CommonService } from 'src/app/Services/common.service';
import { DownloadService } from '../../download/download.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';


@Component({
  selector: 'app-statistics-page',
  templateUrl: './statistics-page.component.html',
  styleUrls: ['./statistics-page.component.css']
})
export class StatisticsPageComponent implements OnInit {

  constructor(
    private shareData: SharingDataService,
    public datepipe: DatePipe,
    public picklistPipe: ToPicklistPipe,
    public route: ActivatedRoute,
    public formularService: FormularService,
    public authService: AuthentService,
    private router: Router,
    private commonService: CommonService,
    private downloadService: DownloadService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    private errorHandlingService: ErrorHandlingService,
    public dialog: MatDialog,
  ) { }

  authRole = AuthenticationRole;

  Input = {
    element: null,
    columns: null
  };

  Language;
  resourceDefinition;
  MS_REQSERV_N;
  MS_REQDOC_STAT;
  MS_REQCASSET_N;
  Picklist;
  G3E_FID;
  id = "";
  isEdit: boolean;
  showLoading = true;
  previousUrl = "";
  id1;
  id2;
  groupName = "V_MS_STAT_ALL";

  statisticForm = StatisticForm;

  MS_REQSERV_NUrlString;
  MS_REQDOC_STATUrlString;
  MS_REQCASSET_NUrlString;
  processingHistoryUrlString;
  plotRequestUrlString;
  processingHistoryDefaultFilter;
  plotRequestUrlStringDEfaultFilter;

  MS_REQSERV_NColumns = [
    { name: "G3E_FID", visible: false, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "G3E_CID", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "STATUS", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "MS_REQSERVICE_STATUS_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "SERVICE", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_SERVICE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REMARK", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
  ]

  MS_REQCASSET_NColumns = [
    { name: "G3E_FID", visible: false, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "G3E_CID", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_SERVICE", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_SERVICE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_G3E_FNO", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_FEATURE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_G3E_FID", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "EXTERNAL_CALL", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "icon", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "externalCall", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null, icon: "search" },
  ]

  MS_REQDOC_STATColumns = [
    { name: "G3E_ID", visible: false, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "G3E_FID", visible: false, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "MAPSHEET_NUM", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "USERNAME", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "DOWNLOAD_DT", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "VALID", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_GIP_VALIDITY_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    // { name: "Download", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "icon", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "download", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, icon: "save" },
  ]

  processingHistory = [
    { name: "MACHINENAME", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "LOGDATE", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "date", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "STEP", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
  ]

  plotRequest = [
    { name: "SHEETNUM",                visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",      columnSearch: false, fromToFilter: true,  picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "SERVICE",                visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist",  columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_SERVICE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "PROCESSING_STATE",       visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist",  columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_PROCESSING_STATE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "SUBMIT_DT",              visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",      columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "LAST_REPRINT_DT",        visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "date",      columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "EXPORT",                 visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist",  columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_EXPORT_SERVICE", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "LAST_PLOT_ID",           visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",      columnSearch: false, fromToFilter: true,  picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "LAST_PLOT_REQUEST_ID",   visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",      columnSearch: false, fromToFilter: true,  picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REQ_ERR",                visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",      columnSearch: true,  fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
  ]

  statisticFormular = [
    { formControlName: "G3E_FID", editReadonly: true, newReadonly: true, readonly: true, title:"cptn_DisplayRequest"},
    { formControlName: "RQTITLE", hidden: true, editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "USERGUID", hidden: true, editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "PERSON_ID", picklist: "V_MS_USER_VL", editReadonly: true, newReadonly: true, readonly: true, translationKey: "C_PERSON_ID",},
    { formControlName: "DELIVERY_STATE", picklist: "V_MS_DELIVERY_STATE_VL_T", editReadonly: true, newReadonly: true, readonly: true,  newRow:true },
    { formControlName: "REQUEST_STATE", picklist: "V_MS_REQUEST_STATE_VL_T", editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "ACTIVITY_TYPE", picklist: "V_MS_ACTIVITY_TYPE_VL_T", editReadonly: true, newReadonly: true, readonly: true,  newRow:true },
    { formControlName: "REASON_TYPE", picklist: "V_MS_REASON_TYPE_VL_T", editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "BEGIN_ACTIVITY_DT", editReadonly: true, newReadonly: true, readonly: true, datepicker: true, newRow:true },
    { formControlName: "END_ACTIVITY_DT", required: false, editReadonly: true, newReadonly: true, readonly: true, datepicker: true, },
    { formControlName: "REQUEST_DT", editReadonly: true, newReadonly: true, readonly: true, datepicker: true},
    { formControlName: "EXPIRATION_DT", editReadonly: true, newReadonly: true, readonly: true, datepicker: true},
    { formControlName: "RESPONSIBLE_PERSON", editReadonly: true, newReadonly: true, readonly: true, newRow:true },
    { formControlName: "RESPONSIBLE_PERSON_TEL_NUM", editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "PERSON_EMAIL", editReadonly: true, newReadonly: true, readonly: true },
    { formControlName: "LOCATION_DESC", editReadonly: true, newReadonly: true, readonly: true, },
    // { formControlName: "LOCATION", editReadonly: true, newReadonly: true, readonly: true, },
    // { formControlName: "COMPANY", editReadonly: true, newReadonly: true, readonly: true, },
    { formControlName: "REQUESTOR", picklist: "V_MS_USER_VL", editReadonly: true, newReadonly: true, readonly: true, translationKey: "C_REQUESTOR", },
    { formControlName: "INTNOTE", editReadonly: true, readonly: true, textArea: true, title: "cptn_internalComFwd"},
    { formControlName: "PERSON_NOTIF", editReadonly: true, newReadonly: true, readonly: true, title: "cptn_InternalCommunication"},
  ]

  action(parameters) {
    this[parameters.action](parameters.element, parameters.column);
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
    this.shareData.currentLanguage.subscribe(data => this.Language = data);

    this.getUrlParams();
    this.setReadonly();
    this.getData();

    if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser)
      this.statisticFormular.forEach(element => {
        if (element.formControlName == "INTNOTE")
          element.hidden = true;
          element.title = null;
          if (element.formControlName == "PERSON_NOTIF")
          element.hidden = true;
          element.title = null;
      }); 
  }

  getUrlParams(){
    this.route.queryParams
    .subscribe(params => {
      if (params.id != "") {
        this.id = params.id;
      }
      if(params.previousUrl){
        this.previousUrl = params.previousUrl;
      }
      if(params.id1){
        this.id1 = params.id1;
      }
      if(params.id2){
        this.id2 = params.id2;
      }
      this.changeToDisplay();
    });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }


  changeToEdit() {
    this.statisticFormular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay() {
    this.statisticFormular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.statisticFormular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  getData() {
    this.formularService.getData([`Statistic/V_MS_STAT_ALL?$filter=${this.id}`], (formularData) => {
      if (formularData[0][0] != undefined) {
        for (var dataElement in formularData[0][0]) {
          for (var statisticElement in this.statisticForm.value) {
            if (dataElement == statisticElement) {
              this.statisticForm.controls[statisticElement].setValue(formularData[0][0][dataElement])
            }
          }
        }
      }

      this.MS_REQSERV_NColumns.forEach(element => {
        if (element.name == "G3E_FID") {
          element.defaultNumberFilter = [formularData[0][0].G3E_FID];
        }
      });

      var temporaryMS_REQSERV_NColumns = this.MS_REQSERV_NColumns;
      this.MS_REQSERV_NColumns = null;
      this.MS_REQSERV_NColumns = temporaryMS_REQSERV_NColumns;

      this.MS_REQSERV_NUrlString = `data/MS_REQSERV_N`;



      this.MS_REQCASSET_NColumns.forEach(element => {
        if (element.name == "G3E_FID") {
          element.defaultNumberFilter = [formularData[0][0].G3E_FID];
        }
      });

      var temporaryMS_REQCASSET_NColumns = this.MS_REQCASSET_NColumns;
      this.MS_REQCASSET_NColumns = null;
      this.MS_REQCASSET_NColumns = temporaryMS_REQCASSET_NColumns;

      this.MS_REQCASSET_NUrlString = `data/MS_REQCASSET_N`;



      this.MS_REQDOC_STATColumns.forEach(element => {
        if (element.name == "G3E_FID") {
          element.defaultNumberFilter = [formularData[0][0].G3E_FID];
        }
      });

      var temporaryMS_REQDOC_STATColumns = this.MS_REQDOC_STATColumns;
      this.MS_REQDOC_STATColumns = null;
      this.MS_REQDOC_STATColumns = temporaryMS_REQDOC_STATColumns;

      this.MS_REQDOC_STATUrlString = `data/V_MS_REQDOC_STAT`;

      this.processingHistoryUrlString = `data/GIP_LOG`;
      this.plotRequestUrlString = `data/V_MS_MAPSH_ERR`;
      this.processingHistoryDefaultFilter = `CORRELATIONID eq '${this.statisticForm.value.G3E_FID}'`;
      this.plotRequestUrlStringDEfaultFilter = `G3E_FID eq ${this.statisticForm.value.G3E_FID}`;

      this.showLoading = false;
    });
  }

  download(element, column) {
    this.downloadService.downloadFile(this.commonService.getGipServicesUrl() + 'file/ReqDocFileTest/' + element.G3E_ID, undefined, this.handlePostError);
  }

  externalCall(){
    
  }

  handlePostError(response: any){
    var error = '';

    if (response.status == 431){
      error = this.translateResourceDefinition.transform("FileTooLarge", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    } else if(response.status == 415){
      error = this.translateResourceDefinition.transform("UnsupportedMediaType", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    }
    else {
      error = this.formularService.getDefaultErrorMessage();
      this.errorHandlingService.showError(error);
    }
  }

  backAction(){
    if(this.authService.currentUser().ROLE == this.authRole.InternalAdmin || this.authService.currentUser().ROLE == this.authRole.InternalUser){
      this.router.navigate([this.previousUrl], { queryParams: { id1: this.id1, id2: this.id2} });
    } else {
      this.router.navigate(["statisticGrid"]);
    }
  }

  Select(element, column, selectedSingleRows, selectedMultiRows){
    const dialogRef = this.dialog.open(statisticModalWindow, {
      data: {logId : element.LOGID}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  restartRequestAction(){
    const dialogRef = this.dialog.open(ConfirmationWindow, {
      data: {
        Title : "RestartRequestConfirmMessage",
        Text : "",
        Placeholders: ["null"],
        Actions: [{
          Text: "ConfirmYes",
          Function: "RESTART",
        },
        {
          Text: "ConfirmNo",
        }]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "RESTART") {
        this.formularService.restartRequest(`plot/restartrequest/${this.statisticForm.value.G3E_FID}/${this.Language}`, (data) => {});
      }
    });
  }
}


@Component({
  selector: 'statisticModalWindow',
  templateUrl: 'statisticModalWindow.html',
})
export class statisticModalWindow {
  resourceDefinition;
  logId;
  urlString;
  defaultFilter;
  Columns = [];
  groupName = "GIP_LOG_PROPERTY";

  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef<statisticModalWindow>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.logId = data.logId;
    this.urlString = `data/GIP_LOG_PROPERTY`;
    this.defaultFilter = `LOGID eq ${this.logId}`;

    this.Columns = [
      { name: "NAME",    visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text",  enableSelect: false,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "VALUE",  visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "text",  enableSelect: false,   columnSearch: true, fromToFilter: false,  picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
    ]
  }

  close() {
    this.dialogRef.close();
  }
}